import { Routes } from '@angular/router';

export const pollsRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/polls/polls.component').then(c => c.PollsComponent),
    data: { pageTitle: 'PAGES.POLLS.TITLE', pageType: 'list', isAnonymous: true }
  },
  {
    path: 'add',
    loadComponent: () => import('./pages/add-edit-poll/add-edit-poll.component').then(c => c.AddEditPollComponent),
    data: { pageTitle: 'PAGES.POLLS.ADD', pageType: 'add', isAnonymous: true }
  },
  {
    path: 'edit/:id',
    loadComponent: () => import('./pages/add-edit-poll/add-edit-poll.component').then(c => c.AddEditPollComponent),
    data: { pageTitle: 'PAGES.POLLS.EDIT', pageType: 'edit', isAnonymous: true }
  }
];

